function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.053 2.093l-9.681 8.391v13.1a.421.421 0 00.421.421h6.314a.421.421 0 00.421-.421v-6.32h5.051v6.314a.421.421 0 00.421.421h6.314a.421.421 0 00.421-.421v-13.1zm2.526 11.378a.421.421 0 01-.421.421h-4.209a.421.421 0 01-.421-.421v-3.367a.421.421 0 01.421-.421h4.209a.421.421 0 01.421.421z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.961 11.047L13.334.103a.421.421 0 00-.55 0L7.171 4.967V1.685a.421.421 0 00-.421-.421H4.634a.421.421 0 00-.421.421v5.842l-4.069 3.52a.425.425 0 10.561.638L13.053.978 25.4 11.685a.415.415 0 00.275.1.421.421 0 00.275-.748z"
}));

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.107,
    height: 24,
    viewBox: "0 0 26.107 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.348aec68.svg";
export { ForwardRef as ReactComponent };